import { useMutation } from '@tanstack/react-query';

import { CoreApiMinimal } from '../api';
import type { User } from './users.types';

type LoginUserViaOAuthParams = {
  provider: string;
  code?: string;
  referralString?: string;
  bodyParams?: {
    cause?: string;
    signup_referral_code?: string;
  };
};

const useLoginUserViaOAuth = () => {
  const loginUserViaOAuth = async ({
    provider,
    code,
    referralString,
    bodyParams,
  }: LoginUserViaOAuthParams) => {
    const params = new URLSearchParams();
    if (code) {
      params.append('code', code);
    }
    if (referralString) {
      params.append('cause', referralString);
    }
    const { data } = await CoreApiMinimal.post<{ user: User }>(
      `/auth/${provider}?${params.toString()}`,
      bodyParams
    );
    return data;
  };

  return useMutation({
    mutationFn: loginUserViaOAuth,
  });
};

export { useLoginUserViaOAuth };
